<template>
    <tr class="ssid-list-item">
        <td>
            {{ item.name }}
        </td>

        <td>
            <i
                class="mdi mdi-square-edit-outline pointer"
                v-tooltip="$t('message.generics.message.edit')"
                @click="showingEditForm = true"
            ></i>
            <i
                class="mdi mdi-delete pointer"
                v-tooltip="$t('message.ssid.message.deleteSSID')"
                @click="showingDeleteModal = true"
            ></i>
        </td>

        <confirmation-modal
            :value="showingDeleteModal"
            :confirm-label="$t('message.generics.message.confirm')"
            @confirm="deleteSSID"
            @cancel="showingDeleteModal = false"
        >
            <span slot="heading">
                {{ $t("message.ssid.message.deleteSSID") }}
            </span>

            <span>
                {{ $t("message.ssid.message.deleteSSIDConfirmation") }}
            </span>
        </confirmation-modal>

        <modal
            v-model="showingEditForm"
            :title="$t('message.ssid.message.editSSID')"
        >
            <v-text-field
                v-model.trim="form.name"
                :label="$t('message.generics.message.name')"
                :name="$t('message.generics.message.name')"
                v-validate="'required'"
                :error-messages="
                    errors.collect($t('message.generics.message.name'))
                "
            ></v-text-field>

            <app-button
                primary
                :label="$t('message.generics.message.edit')"
                class="mx-auto btn btn-primary btn-round"
                :disabled="!form.name"
                @click="editSSID"
            ></app-button>
        </modal>
    </tr>
</template>

<script>
import EventBus from "@packages/event-bus";
import AppButton from "@/components/generic/button/Button";
import Modal from "@/components/generic/Modal";
import ConfirmationModal from "@components/ConfirmationModal";
import LocalSsidCreateForm from "./modal/LocalSSIDCreateForm.vue";

export default {
    components: {
        Modal,
        AppButton,
        ConfirmationModal,
        LocalSsidCreateForm,
    },

    data() {
        return {
            showingDeleteModal: false,
            showingEditForm: false,
            form: {
                name: undefined,
            },
        };
    },

    props: {
        item: {
            type: Object,
        },
    },

    watch: {
        showingEditForm(value) {
            if (!value) {
                this.form = { ...this.item };
            }
        },
    },

    methods: {
        async deleteSSID() {
            try {
                await this.$api.core.ssid.delete(this.item.id);

                this.showingDeleteModal = false;

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: this.$t(
                        "message.ssid.message.removeSuccessMessage"
                    ),
                });

                this.$emit("deleted");
            } catch (error) {
                console.lg(error);
            }
        },

        async editSSID() {
            try {
                await this.$api.core.ssid.update({
                    ...this.form,
                });

                this.showingEditForm = false;

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: this.$t("message.ssid.message.editSuccessMessage"),
                });

                this.$emit("edited");
            } catch (error) {
                console.log(error);
            }
        },
    },

    mounted() {
        this.form = { ...this.item };
    },
};
</script>
